import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { Phone } from "lucide-react";

interface PhoneInputProps {
  initialValue?: string;
  onPhoneChange?: (value: string) => void;
}

export interface PhoneInputRef {
  getValue: () => string;
  setValue: (value: string) => void;
}

const PhoneInput = forwardRef<PhoneInputRef, PhoneInputProps>(
  ({ initialValue = "", onPhoneChange }, ref) => {
    const [value, setValue] = useState(initialValue);

    console.log("🔥 PhoneInput component rendering with value:", value);

    useEffect(() => {
      setValue(initialValue);
    }, [initialValue]);

    useImperativeHandle(ref, () => ({
      getValue: () => value,
      setValue: (newValue: string) => setValue(newValue),
    }));

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;
      console.log("🔥 PhoneInput handleChange:", newValue);
      setValue(newValue);
      onPhoneChange?.(newValue);
    };

    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          <Phone className="w-4 h-4 inline mr-2" />
          Phone Number
        </label>
        <input
          type="text"
          value={value}
          onChange={handleChange}
          onFocus={(e) => {
            console.log("🔥 PhoneInput FOCUS event:", e.target);
          }}
          onBlur={(e) => {
            console.log("🔥 PhoneInput BLUR event:", e.target);
          }}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Enter phone number"
          autoComplete="tel"
        />
      </div>
    );
  }
);

PhoneInput.displayName = "PhoneInput";

export default PhoneInput;
